import React from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import macMockup from '../../../Assets/images/DFL/landing-page-img/mac-mockup.png'
import DaimondGif from '../../../Assets/images/DFL/landing-page-img/diamond-iframe.gif'
import { NavLink } from 'react-router-dom'

const LooseDiamondPage = () => {
    return (
        <>
            <div className='dfld_loose_diamond_Section'>
                <Container className='dfl_custome_container_staticpage'>
                    <Row className='w-100 m-auto'>
                        <Col sm={12} md={6} lg={6} className="dfld_looss_img">
                            <div className='dhld_gif_box position-relative'>
                                <Image src={macMockup} alt="Mockup Image" className='img-fluid' />
                                <div className='dfl_diamond_gif'>
                                    <Image src={DaimondGif} alt=" Diamond GIF" className='dfl_diamond_gif' />
                                </div>
                            </div>
                        </Col>
                        <Col sm={12} md={6} lg={6}>
                            <div className='dfld_loose_text_box'>
                                <div className="eng-box3 text-center ">
                                    <div>
                                        <h2>VIEW DIAMONDS IN 360 HD & <b className='dfl_d_font_waight_900'>IN PERSON </b>
                                            THE SMART WAY TO BUY DIAMONDS</h2>
                                        {/* <h1> 360° HD </h1> */}
                                        {/* <h3 class="title24 text-uppercase m10">The Smart Way to Buy Diamonds</h3> */}
                                    </div>
                                    <p>
                                        A certificate tells a small part of the story but only seeing the loose diamond <b className='dfl_d_font_waight_800'>IN PERSON</b> will help you know its THE ONE"
                                    </p>
                                    <p>Personalize your engagement ring by designing it with the perfect loose diamond of your choice.</p>
                                    <div className="eng-btn ">
                                        <div className="btn-wrapper row text-center pt-0">
                                            <div className="col-md-6 col-sm-6 col-lg-6 col-xs-12">
                                                <NavLink
                                                    className="btn-engage"
                                                    to="/diamonds"
                                                >
                                                    Earth Mined
                                                </NavLink>
                                            </div>
                                            <div className="col-md-6 col-sm-6 col-lg-6 col-xs-12">
                                                <NavLink
                                                    className="btn-engage"
                                                    to="/diamonds/lab"
                                                >
                                                    Lab Created
                                                </NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default LooseDiamondPage